import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

const CountryGuard = ({ children }) => {
  const location = useLocation();

  const isEnglishUnavailable = location.pathname === "/english-unavailable";

  const [isPoland, setIsPoland] = useState(null);

  useEffect(() => {
    // Na stronie informacyjnej nie sprawdzamy kraju
    if (isEnglishUnavailable) {
      return;
    }

    const checkCountry = async () => {
      try {
        const response = await fetch(
          "https://twojaopiekunka.pl/api/check-country",
        );

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }

        const data = await response.json();

        console.log("Country:", data.country);
        console.log("Is Poland:", data.isPoland);

        setIsPoland(data.isPoland);
      } catch (error) {
        console.error("Country check failed:", error);

        // Jeśli GeoIP nie działa, nie blokujemy serwisu
        setIsPoland(true);
      }
    };

    checkCountry();
  }, [isEnglishUnavailable]);

  // Tej strony nie blokujemy
  if (isEnglishUnavailable) {
    return children;
  }

  // Czekamy na wynik GeoIP
  if (isPoland === null) {
    return null;
  }

  // IP spoza Polski
  if (!isPoland) {
    return <Navigate to="/english-unavailable" replace />;
  }

  return children;
};

export default CountryGuard;
